"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProfileCreateByPhone = void 0;
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const models_1 = require("../../api/admin/classes/models");
const AuthTypeEnum_1 = require("../../enums/AuthTypeEnum");
const StateProfile_1 = require("./StateProfile");
class StateProfileCreateByPhone extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageCreateProfileByPhone, "Create profile by phone", true);
        this.page.ctrls.btnCreate.onclick = () => this.tryCreate();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.start.call(this);
        });
    }
    tryCreate() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            const auth = new models_1.Authenticator();
            auth.authType = AuthTypeEnum_1.AuthTypeEnum.Phone.toString();
            auth.data = data.phone;
            auth.confirmed = true;
            const user = yield this.lockgui(this.app.api.admin.profiles.createUser(auth));
            if (!user)
                return;
            new modalCom.DialogOk("User created").show();
            yield gs_1.StateGS.Run(StateProfile_1.StateProfile, user);
        });
    }
}
exports.StateProfileCreateByPhone = StateProfileCreateByPhone;
StateProfileCreateByPhone.StateName = "createProfileByPhone";
//# sourceMappingURL=StateProfileCreateByPhone.js.map